export const DEPLOYMENT_DATA = "DEPLOYMENT_DATA";